<template>
  <div class="content">
    <card>
      <div class="row">
        <div class="col-md-2">
          <el-select @change="getBanners" class="select-primary" size="large" placeholder="선택" v-model="state.state">
            <el-option v-for="option in state.options" class="select-primary" :value="option.value" :label="option.label" :key="option.label" />
          </el-select>
        </div>
        <div class="col-md-2">
          <el-select @change="getBanners" class="select-primary" size="large" placeholder="선택" v-model="type">
            <el-option v-for="option in types" class="select-primary" :value="option.type" :label="option.name" :key="option.type" />
          </el-select>
        </div>
        <div v-if="state.state === 1" class="col-md-4">
          <base-button @click="setBannerOrder" type="default">노출순서변경</base-button>

          <el-popover trigger="hover" placement="top">
            <div>
              <div class="popover-body">드래그앤드랍으로 노출순서를 변경할 수 있습니다</div>
            </div>
            <base-button slot="reference"> ? </base-button>
          </el-popover>
        </div>
        <base-button @click="goBannerForm()" type="default">배너 등록</base-button>
      </div>
    </card>
    <draggable class="row" v-model="banners" group="people" @start="drag = true" @end="drag = false">
      <div class="col-sm-3" v-for="(item, index) in banners">
        <card class="card">
          <div class="row">
            <img v-if="item.imageFileUrl" slot="image" class="card-img-top cover-img" v-bind:src="item.imageFileUrl" :alt="item.title" />
            <img v-else src="@/assets/img/blip-logo.png" />
          </div>
          <p>{{ item.typeName }}</p>
          <p class="card-text">{{ item.startTime }}</p>
          <p>{{ item.endTime }}</p>
          <base-button @click="goBannerForm(item.id)" type="default">상세</base-button>
        </card>
      </div>
    </draggable>
  </div>
</template>
<script>
import { BaseButton, Card } from "@/components/index";
import draggable from "vuedraggable";
import { formatDateTime } from "../../util/DateUtils";
import { HomepageBannerType } from "@/pages/Homepage/HomepageBannerType";

export default {
  components: {
    Card,
    BaseButton,
    draggable,
  },
  async created() {
    this.types = [{ name: "전체", type: null }, ...this.types];
    await this.getBanners();
  },
  data() {
    return {
      state: {
        state: 1,
        options: [
          { label: "전체", value: null },
          { label: "표시", value: 1 },
          { label: "숨김", value: 0 },
        ],
      },
      type: 10,
      banners: [],
      types: HomepageBannerType,
    };
  },
  methods: {
    async getBanners() {
      return this.$axios.get(`/homepage/banners`, { params: { state: this.state.state, type: this.type } }).then((res) => {
        this.banners = res.data.data.map((banner) => {
          banner.imageFileUrl = window.Endpoints.imageServerUrl + banner.imageFileId;
          banner.startTime = formatDateTime(banner.startTime);
          banner.endTime = formatDateTime(banner.endTime);
          banner.typeName = this.types
            .map((type) => {
              if (type.type === banner.type) {
                return type.name;
              } else {
                return null;
              }
            })
            .filter((type) => type !== null)
            .toString();
          return banner;
        });
      });
    },
    async setBannerOrder() {
      const banners = [];
      this.banners.forEach((banner, order) => {
        banners.push({ bannerId: banner.id, order });
      });
      return this.$axios.put("/homepage/banners/order", { banners }).then((res) => {
        window.Toast.success("배너의 노출순서가 변경되었습니다");
        this.getBanners();
      });
    },
    goBannerForm(bannerId) {
      if (bannerId) {
        this.$router.push(`/homepage/bannerForm?bannerId=${bannerId}`);
      } else {
        this.$router.push(`/homepage/bannerForm`);
      }
    },
  },
};
</script>
<style></style>
